export default __webpack_public_path__ + "static/949-0993f522fafd017707199d995eafa173.gif";